import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import axios from "../axios-auth";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      email: "",
      uuid: "",
      name: "",
      picture: "",
    },
    url: "",
    singleVideo: null,
    singleComment: null,
    singleProfile: null,
    connected: false,
    loading: false,
    isLoggedIn: false,
  },
  mutations: {
    userData(state, data) {
      state.user = {
        email: typeof data.email !== "undefined" ? data.email : data.id,
        uuid: data.id,
        name: data.name,
        picture: data.picture,
      };
    },
    url(state, url) {
      state.url = url;
    },
    isLoggedIn(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
    singleVideoData(state, data) {
      state.singleVideo = data;
    },
    singleCommentData(state, data) {
      state.singleComment = data;
    },
    singleProfileData(state, data) {
      state.singleProfile = data;
    },
  },
  actions: {
    fbLogin({ commit, dispatch }, data) {
      if (data.auth && data.user) {
        let newEmail = "";
        if (typeof data.user.email !== "undefined") {
          if (data.user.email.length !== 0) {
            newEmail = data.user.email;
          } else {
            newEmail = data.user.id;
          }
        } else {
          newEmail = data.user.id;
        }
        commit("isLoggedIn", true);
        const newUser = {
          ...data.auth,
          userID: data.user.id,
          name: data.user.name,
          email: newEmail,
          avatar: data.user.picture.data.url,
        };

        const url =
          "https://shaga3app.com/webServices/odetlebsmido/firstOrCreate.php";
        axios
          .post(url, newUser, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            if (res.data.Res_code === 1) {
              // router.push("/home");
              dispatch("getUrl", {
                user_id: res.data.user.id,
                token: res.data.user.jwt,
              });
              // let text = `user login:
              //   userId: ${res.data.user.id},
              //   email: ${newEmail},
              //   from: ${process.env.VUE_APP_CURRENT_URL} `;
              // const url =
              //   "https://slack.com/api/chat.postMessage?token=xoxp-316268391537-565983672662-679901340661-643ef055ab95bb2cffff4f485174075e&channel=G015P17ECS1&text=" +
              //   text;
              // axios.get(url, {
              //   headers: { "Content-Type": "application/json" },
              // });
            }
          })
          .catch((err) => {
            let text = " error 1: " + JSON.stringify(err);
            url =
              "https://slack.com/api/chat.postMessage?token=xoxp-316268391537-565983672662-679901340661-643ef055ab95bb2cffff4f485174075e&channel=G015P17ECS1&text=" +
              text;
            axios.get(url, {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
            });
            // alert(text);
            alert(JSON.stringify(err));
            console.log(err);
          });
      }
      commit("userData", data.user);
    },
    getUrl({ commit, dispatch }, data) {
      if (data.token && data.user_id) {
        let url =
          "https://shaga3app.com/webServices/odetlebsmido/getWebView.php";
        let body = {
          user_id: data.user_id,
        };
        axios
          .post(url, body, {
            headers: { "Content-Type": "application/json", JWT: data.token },
          })
          .then((res) => {
            if (res.data.Res_code === 1) {
              url = process.env.VUE_APP_CURRENT_BACKEND_URL + res.data.url;
              // url = "https://backend.shaga3app.com" + res.data.url;
              axios
                .get(url, {
                  maxRedirects: 0,
                  headers: {
                    "x-auth-signature": res.data.signature,
                    "x-shaga3app-id": "odetlebsmido",
                    "x-locale":
                      localStorage.getItem("lang") === "ar" ? "ar" : "en",
                    "x-platform": "web",
                  },
                })
                .then((res) => {
                  if (res.data) {
                    if (res.data.token) {
                      localStorage.setItem("newT", res.data.token);
                      dispatch("saveUrl");
                    }
                  }
                })
                .catch((err) => {
                  let text = " error: 2 " + JSON.stringify(err);
                  const url =
                    "https://slack.com/api/chat.postMessage?token=xoxp-316268391537-565983672662-679901340661-643ef055ab95bb2cffff4f485174075e&channel=G015P17ECS1&text=" +
                    text;
                  axios.get(url, {
                    headers: { "Content-Type": "application/json" },
                  });
                  console.log(err);
                });
            }
          })
          .catch((err) => {
            let text = " error: 3" + JSON.stringify(err);
            const url =
              "https://slack.com/api/chat.postMessage?token=xoxp-316268391537-565983672662-679901340661-643ef055ab95bb2cffff4f485174075e&channel=G015P17ECS1&text=" +
              text;
            axios.get(url, { headers: { "Content-Type": "application/json" } });
            console.log(err);
          });
      }
    },
    saveUrl({ commit, state }) {
      let token = localStorage.getItem("newT");
      let lang = localStorage.getItem("lang") === "ar" ? "ar" : "en";
      if (token && token.length > 0) {
        let url = `${process.env.VUE_APP_CURRENT_FRONTEND_URL}/?token=${token}&language=${lang}`;
        // let url = `https://frontend.shaga3app.com/?token=${token}&language=${lang}`;

        let vid = sessionStorage.getItem("vid");
        if (state.singleVideo) {
          url = `${process.env.VUE_APP_CURRENT_FRONTEND_URL}/?token=${token}&language=${lang}&v=${state.singleVideo}`;
          // url = `https://frontend.shaga3app.com/?token=${token}&language=${lang}&v=${state.singleVideo}`;
        } else if (vid) {
          url = `${process.env.VUE_APP_CURRENT_FRONTEND_URL}/?token=${token}&language=${lang}&v=${vid}`;
          // url = `https://frontend.shaga3app.com/?token=${token}&language=${lang}&v=${vid}`;
        }

        let com = sessionStorage.getItem("com");
        if (state.singleComment) {
          url = `${process.env.VUE_APP_CURRENT_FRONTEND_URL}/?token=${token}&language=${lang}&c=${state.singleComment}`;
          // url = `https://frontend.shaga3app.com/?token=${token}&language=${lang}&c=${state.singleComment}`;
        } else if (com) {
          url = `${process.env.VUE_APP_CURRENT_FRONTEND_URL}/?token=${token}&language=${lang}&c=${com}`;
          // url = `https://frontend.shaga3app.com/?token=${token}&language=${lang}&c=${com}`;
        }

        let pro = sessionStorage.getItem("pro");
        let compid = sessionStorage.getItem("compid");
        if (state.singleProfile) {
          url = `${process.env.VUE_APP_CURRENT_FRONTEND_URL}/?token=${token}&language=${lang}&cid=${state.singleProfile.competitionId}&p=${state.singleProfile.profile}`;
          // url = `https://frontend.shaga3app.com/?token=${token}&language=${lang}&cid=${state.singleProfile.competitionId}&p=${state.singleProfile.profile}`;
        } else if (pro && compid) {
          url = `${process.env.VUE_APP_CURRENT_FRONTEND_URL}/?token=${token}&language=${lang}&cid=${compid}&p=${pro}`;
          // url = `https://frontend.shaga3app.com/?token=${token}&language=${lang}&cid=${compid}&p=${pro}`;
        }

        commit("url", url);
        if (router.currentRoute.path === "/") {
          router.push("/home");
        }
      }
    },
    saveSingleVideoData({ commit }, data) {
      commit("singleVideoData", data);
    },
    saveSingleCommentData({ commit }, data) {
      commit("singleCommentData", data);
    },
    saveSingleProfileData({ commit }, data) {
      commit("singleProfileData", data);
    },
  },
  getters: {
    connected: (state) => {
      return state.connected;
    },
    url: (state) => {
      return state.url;
    },
    isLoggedIn: (state) => {
      return state.isLoggedIn;
    },
  },
});
